<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div  class='h100vh-100'>
          <div class="h-toolbarBg">
            <ejs-toolbar>
              <e-items>
                <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="refreshLog"></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Alarm.remove")' :click="deleteLog"></e-item>
              </e-items>
            </ejs-toolbar>
            <div class="h-inputBox">
              <input class="e-input" :placeholder='$t("Alarm.inputTip")' @keyup.enter="getCallBackLog" v-model="keyString" />
            </div>
          </div>
          <div class="h100-40 width-100vw h-scroll">
              <ejs-grid ref='grid' height='calc(100% - 0px)' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :pageSettings="pageSettings">
              <e-columns>
                <e-column type="checkbox" width="50" textAlign="center"></e-column>
                <!--<e-column field="id" :visible="false"></e-column>-->
                <e-column field="logId" :headerText='$t("Alarm.logId")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field="callTitle" :headerText='$t("Alarm.callTitle")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field="callResult" :headerText='$t("Alarm.callResult")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field="callLog" :headerText='$t("Alarm.callLog")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field="callContent" :headerText='$t("Alarm.callContent")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
                <!--<e-column field="sysTaskId" :headerText='$t("System.timeTaskId")' width="120" textAlign="center" :visible="false"></e-column>-->
                <!-- <e-column field="description" :headerText='$t("System.description")'  width="120" textAlign="center" clipMode='EllipsisWithTooltip'></e-column> -->
                <e-column
                  field="startTime"
                  isPrimaryKey="true"
                  :headerText='$t("Alarm.callTime")'
                  format="yMd"
                  textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'
                ></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-pager
              ref="pager"
              :pageSize="pageSettings.pageSize"
              :pageCount="pageCount"
              @click="getCallBackLog"
            ></ejs-pager>
          </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from "../../components/common/CustomDialog";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "CallBackLogPage",
  components: {
    BasicLayout
  },
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.callBackLog')}` },
      keyString: "",
      pageNo: "1",
      pageSettings: { pageSize: 25 },
      pageCount: "4",
      selectionOptions: { type: 'Multiple' }
    };
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  },
  methods: {
    refreshLog(){
      this.$loading.showLoadding(`${this.$t('System.loading')}`);
      this.getCallBackLog();
    },
    getCallBackLog() {
      const url = "/lte/ems/fm/callback/queryLogByPage?keyword="+this.keyString;
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.post(url, params).then(response => {
        this.$loading.hideLoadding();
        let result = response.data.resultVal.result;
        let showRe = [];
        result.forEach((item, index) => {
          let re = {};
          re.id = item.id;
          re.logId = item.logId;
          re.callTitle = item.callTitle;
          re.callLog = item.callLog;
          re.callContent = item.callContent;
          if (item.callResult === 1) {
            re.callResult = `${this.$t('Alarm.callFail')}`;
          } else {
            re.callResult = `${this.$t('Alarm.callSuccess')}`;
          }
          re.startTime = item.startTimeStr;
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          response.data.resultVal.totalCount;
      });
    },
    deleteLog() {
      let selectedData = this.$refs.grid.getSelectedRecords();
      if (selectedData == null || selectedData == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      let params = [];
      selectedData.forEach((item, index) => {
        params.push(item.id);
      });
      const url = "/lte/ems/fm/callback/deleteLog";
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.getCallBackLog();
      });
    },
  },
  mounted() {
    this.getCallBackLog();
  }
};
</script>

<style>
</style>
